import React from "react";

export default function HoliFrame1({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-1hol1{fill:#fff}.cls-1hol2{fill:#fbdf07}.cls-1hol3{fill:#f45611}.cls-1hol4{fill:#bb1def}.cls-1hol5{fill:#5aaddb}.cls-1hol6{fill:#89cffd}.cls-1hol7{fill:#ff7f3f}.cls-1hol8{fill:#e02278}.cls-1hol9{fill:#f94892}"
            }
          </style>
        </defs>
        <path
          d="M347.27 347.3c44.2 167.38-32.73 351.24-52.12 346.25-14.68-3.78 17.44-112.27-32.06-215.04-35.13-72.94-84.18-76.68-84.18-131.22 0-72.47 37.69-131.22 84.18-131.22 50.15 0 76.81 103.32 84.18 131.22Z"
          className="cls-1hol9"
        />
        <path
          d="M1072.48 246.85c0 38.69-48.82 41.34-83.79 93.08-33.06 48.92-29.54 99.67-28.07 128.57h-28.76c-27.15-42.66-58.98-135.25-26.96-221.65 7.33-19.79 33.87-93.08 83.79-93.08 46.27 0 83.79 41.68 83.79 93.08Z"
          className="cls-1hol7"
        />
        <path
          d="M1156.46 422.55c-15.53 19.03-40.61.74-78.59 12.15-23.62 7.1-39.77 20.94-51.15 33.8-14.41 16.28-21.18 30.97-25.8 28.43-3.5-1.92-4.37-12.97-1.65-28.43 5.75-32.82 27.63-85.54 74.75-113.23 11.55-6.79 54.04-32.19 78.59-12.15 22.77 18.58 24.49 54.15 3.85 79.43Z"
          className="cls-1hol6"
        />
        <path
          d="M1161.91 174.04c53.91-14.93 103.06 33.33 100 43.09-2.32 7.39-32.38-14.25-67.28 6.44-24.77 14.68-29.83 39.78-46.24 37.22-21.81-3.4-36.46-25.57-32.73-49.52 4.03-25.84 37.25-34.73 46.24-37.22Z"
          className="cls-1hol4"
        />
        <path
          d="M1271.37 308.03c73.02 48.92 103.83 145.56 94.54 150.28-7.04 3.58-30.44-48.91-84.08-71.3-38.07-15.89-58.62-.55-76.74-21.41-24.08-27.72-28.77-63.08-10.46-78.98 19.74-17.15 64.57 13.26 76.74 21.41Z"
          className="cls-1hol7"
        />
        <path
          d="M1438.75 346.78c-5.79 54.69-50.3 99.93-55.63 96.17-4.03-2.85 18.2-31.12 14.95-67.34-2.31-25.71-16.79-32.61-10.53-48.73 8.32-21.42 26.53-34.32 40.67-28.83 15.25 5.93 11.49 39.61 10.53 48.73Z"
          className="cls-1hol3"
        />
        <path
          d="M1452.44 171.46c-85.5 31.2-117.56 135.85-106.1 145.06 8.68 6.97 34.14-47.34 97.65-53.95 45.08-4.7 70.68 21.56 91.44 3.32 27.58-24.24 31.36-65.03 8.45-91.11-24.72-28.13-77.19-8.52-91.44-3.32Z"
          className="cls-1hol6"
        />
        <path
          d="M1630.87 438.43c-11.72 37.48-62.2 24.52-113.46 63.53-3.34 2.54-6.5 5.14-9.5 7.8-20.92-25.21-52.49-41.26-87.81-41.26h-.45c7.37-28.84 20.19-57.71 40.7-83.38 13.46-16.85 62.67-79.41 113.46-63.53 47.09 14.72 72.63 67.03 57.06 116.84Z"
          className="cls-1hol9"
        />
        <path
          d="M1857.84 282.2c-3.42 120.93-96.12 225.96-108.83 218.35-9.62-5.76 35.67-70.68 21.92-149.88-9.76-56.22-43.75-69.57-32.43-105.78 15.04-48.12 53.96-78.77 86.91-68.47 35.55 11.11 33 85.62 32.43 105.78Z"
          className="cls-1hol4"
        />
        <path
          d="M1688.41 231.12c28.23 48.31 12.92 111.98 5.4 112.07-5.69.07-1.55-36.39-27.14-64.16-18.16-19.71-36.53-16.73-40.42-33.69-5.16-22.53 4.57-43.99 21.74-47.91 18.51-4.24 35.71 25.64 40.42 33.69Z"
          className="cls-1hol9"
        />
        <path
          d="M1711.11 398.81c-10.1-32.24 17.82-63.02 23.74-61.39 4.48 1.23-7.86 19.89 5.28 40.51 9.33 14.64 24.5 17.14 23.31 27.11-1.58 13.25-14.57 22.6-29.02 20.88-15.59-1.86-21.63-21.74-23.31-27.11Z"
          className="cls-1hol8"
        />
        <path
          d="M1666.94 689.18c-18.28-31.42 3.67-70.36 10.27-70.07 5 .23-3.51 22.74 15.2 41.24 13.28 13.13 29.78 12.14 30.92 22.88 1.5 14.28-9.9 27.18-25.47 28.83-16.79 1.77-27.87-17.65-30.92-22.88Z"
          className="cls-1hol5"
        />
        <path
          d="M1625.88 503.67c40.18-56.31 122.84-60.79 127.19-50.85 3.3 7.53-41.41 16.24-59.21 61.03-12.64 31.79 1.22 55.02-16.29 66.78-23.27 15.63-53.71 11.07-67.98-10.18-15.4-22.92 9.59-57.4 16.29-66.78ZM1270.46 468.5h-83.04c55.9-23 103.65-27.51 106.7-19.26 1.51 4.08-8.44 9.86-23.66 19.26Z"
          className="cls-1hol2"
        />
        <path
          d="M1844.97 616.2c-35.26 55.84-116.25 54.27-121.28 43.54-3.81-8.12 39.51-13.85 53.63-59.34 10.02-32.29-5.37-57.63 10.97-68.6 21.71-14.58 52-7.51 67.65 15.79 16.88 25.14-5.09 59.29-10.97 68.6Z"
          className="cls-1hol7"
        />
        <path
          d="M1747.4 593.03c-16.19 25.64-53.38 24.92-55.69 20-1.75-3.73 18.14-6.36 24.63-27.25 4.6-14.83-2.46-26.46 5.04-31.5 9.97-6.7 23.88-3.45 31.07 7.25 7.75 11.54-2.34 27.23-5.04 31.5ZM1617.95 340.04c-32.46-36.32-37.18-92.13-31.75-93.34 4.11-.92 10.16 30.33 35.61 49.8 18.06 13.82 30.64 8.53 37.66 22.19 9.34 18.15 7.61 37.65-3.86 43.54-12.37 6.36-32.25-16.14-37.66-22.19Z"
          className="cls-1hol3"
        />
        <path
          d="M1342.52 198.15c-35.1 10.8-68.72-19.19-66.96-25.54 1.33-4.81 21.69 8.46 44.12-5.63 15.92-10 18.6-26.27 29.47-24.98 14.44 1.71 24.67 15.66 22.84 31.16-1.98 16.72-23.62 23.18-29.47 24.98Z"
          className="cls-1hol5"
        />
        <path
          d="M729.05 203.32c-16.79 32.66-61.73 35.77-65.05 30.07-2.51-4.31 21.21-9.61 26.8-35.5 3.97-18.38-5.8-31.66 2.71-38.54 11.31-9.14 28.44-6.71 38.25 5.43 10.59 13.1.09 33.1-2.71 38.54Z"
          className="cls-1hol4"
        />
        <path
          d="M349.38 302.21c-17.38-24.15-3.07-57.71 2.26-58.01 4.04-.22-.88 18.84 15.75 32.41 11.8 9.63 24.98 7.47 26.81 16.15 2.43 11.53-5.63 22.99-18 25.6-13.35 2.81-23.91-12.12-26.81-16.15Z"
          className="cls-1hol3"
        />
        <path
          d="M457.61 370.93c7.39-28.82 42.32-39.36 45.96-35.46 2.76 2.95-15.02 11.41-14.77 32.86.17 15.23 10.28 23.96 4.8 30.93-7.29 9.26-21.25 10.42-31.19 2.6-10.72-8.44-6.03-26.12-4.8-30.93Z"
          className="cls-1hol4"
        />
        <path
          d="M179.45 172.86c28.59-8.22 55.37 16.57 53.85 21.69-1.15 3.87-17.44-7.18-35.82 3.9-13.05 7.86-15.46 21-24.24 19.79-11.67-1.6-19.74-13.05-18.03-25.58 1.85-13.52 19.48-18.42 24.24-19.79Z"
          className="cls-1hol5"
        />
        <path
          d="M199.2 467.22c26.51 13.5 29.17 49.9 24.56 52.6-3.48 2.05-7.85-17.15-28.84-21.6-14.9-3.16-25.63 4.8-31.23-2.08-7.44-9.13-5.53-23.01 4.28-31 10.58-8.62 26.81-.18 31.23 2.08Z"
          className="cls-1hol8"
        />
        <path
          d="M1552.05 687.32c-5.72 4.98-11.7 9.38-17.86 13.25V582.59c0-10.12-1.32-19.94-3.8-29.28 28.68.09 55.36 18.1 65.05 46.66 13.16 38.81-31.4 76.93-43.39 87.35Z"
          className="cls-1hol6"
        />
        <path
          d="M754.72 291.24c25.38 96.59 133.9 146.11 144.76 135.08 8.22-8.35-47.28-43.56-48.5-112.94-.86-49.25 29.46-73.08 11.94-98.05-23.29-33.19-66.39-43.1-96.26-22.14-32.23 22.61-16.17 81.95-11.94 98.05Z"
          className="cls-1hol9"
        />
        <path
          d="M455.44 650.79v95.46c-74.97 9.23-132.49-.79-136.35-14.87-4.54-16.54 68.13-27.24 136.35-80.59ZM807.76 468.5H569.54c-3.25 0-6.46.14-9.64.41 6.95-36.67 12.18-64.89 43.67-80.47 76.35-37.78 164.31-15.74 196.45 49.22 4.92 9.94 7.32 20.3 7.74 30.84ZM147.8 622.07c24.28 67.77 113.21 78.97 121.46 67.84 6.24-8.43-39.65-21.73-43.47-74.6-2.71-37.53 20.59-63.27 5.54-78.09-20.01-19.7-54.93-16.67-77.99 6.76-24.88 25.27-9.58 66.79-5.54 78.09Z"
          className="cls-1hol2"
        />
        <path
          d="M475.1 506.79c-.85 5.9-2.04 11.66-3.52 17.29-3.32 12.6-8.09 24.48-13.82 35.51v.02c-30.1 58.01-86.38 92.61-94.5 86.15-7.84-6.24 36.58-44.89 31.18-106.26-3.84-43.56-32.1-60.43-19.36-84.86 16.92-32.47 53.04-47.11 80.66-32.71 29.79 15.53 21.5 70.08 19.36 84.86ZM528.64 165.01c-57.91 29.41-26.48 111.27-11.07 117.53 11.67 4.74 3.18-38.32 55.67-47.55 37.26-6.55 74.95 11.77 82.91-3.5 10.58-20.29-9.39-51.62-44.6-69.98-37.98-19.8-73.26-1.41-82.91 3.5Z"
          className="cls-1hol7"
        />
        <path
          d="M438.95 187.53c36.2 66.5 3.52 150.55-8 150.15-8.72-.3 2.9-48.73-32.23-87.6-24.94-27.59-53.5-24.87-56.98-47.79-4.62-30.47 13.39-58.47 40.23-62.55 28.95-4.39 50.94 36.71 56.98 47.79ZM630.01 273.74c-73.89 37.69-115.13 123.79-107.18 129.1 6.02 4.03 34.58-42.05 87.06-57.23 37.25-10.77 54.19 5.51 73.69-11.9 25.9-23.13 34.91-55.32 20.12-71.88-15.96-17.86-61.37 5.62-73.69 11.9Z"
          className="cls-1hol6"
        />
        <path
          d="M1661.64 1646.02c-44.2-178.95 32.73-375.52 52.12-370.18 14.68 4.04-17.44 120.03 32.06 229.9 35.13 77.98 84.18 81.98 84.18 140.28 0 77.48-37.69 140.28-84.18 140.28-50.15 0-76.81-110.46-84.18-140.28Z"
          className="cls-1hol2"
        />
        <path
          d="M1115.99 1767.51c-7.34 19.79-33.88 93.08-83.79 93.08-46.28 0-83.79-41.68-83.79-93.08 0-38.69 48.82-41.34 83.79-93.08 32.53-48.14 29.64-98.06 28.13-127.18-.78-14.97-1.19-24.45 3.78-25.36 5.41-.99 15.31 8.53 25.8 25.36 26.94 43.25 57.75 134.78 26.08 220.26Z"
          className="cls-1hol9"
        />
        <path
          d="M1003.49 1547.25c-10.34 30.78-31.75 67.74-68.59 89.39-11.56 6.79-54.04 32.19-78.6 12.15-22.76-18.58-24.49-54.15-3.84-79.44 15.53-19.03 40.61-.73 78.59-12.14 8.52-2.56 16.07-6 22.77-9.96h49.67Z"
          className="cls-1hol3"
        />
        <path
          d="M847.01 1828.35c-53.91 14.93-103.06-33.33-100-43.09 2.32-7.39 32.38 14.25 67.28-6.44 24.77-14.68 29.83-39.78 46.24-37.22 21.81 3.4 36.46 25.57 32.73 49.52-4.03 25.84-37.25 34.73-46.24 37.22Z"
          className="cls-1hol5"
        />
        <path
          d="M749.51 1706.33c-73.02-48.92-103.83-145.56-94.54-150.28 7.04-3.58 30.44 48.91 84.08 71.3 38.07 15.89 58.62.55 76.74 21.41 24.08 27.72 28.77 63.08 10.46 78.98-19.74 17.15-64.57-13.26-76.74-21.41Z"
          className="cls-1hol2"
        />
        <path
          d="M570.16 1655.61c5.79-54.69 50.3-99.93 55.63-96.17 4.03 2.85-18.2 31.12-14.95 67.34 2.31 25.71 16.79 32.61 10.53 48.73-8.32 21.42-26.53 34.32-40.67 28.83-15.25-5.93-11.49-39.61-10.53-48.73Z"
          className="cls-1hol3"
        />
        <path
          d="M556.47 1820.45c85.5-31.2 117.56-135.85 106.1-145.06-8.68-6.97-34.14 47.34-97.65 53.95-45.08 4.7-70.68-21.56-91.44-3.32-27.58 24.24-31.36 65.03-8.45 91.11 24.72 28.13 77.19 8.52 91.44 3.32Z"
          className="cls-1hol3"
        />
        <path
          d="M585.45 1547.25c-7.7 24.32-19.55 48.32-36.89 70.02-13.46 16.85-62.67 79.41-113.45 63.53-47.09-14.72-72.64-67.03-57.06-116.84 11.02-35.26 56.35-25.88 104.37-57.14 20.92 24.73 52.19 40.43 87.12 40.43h15.91Z"
          className="cls-1hol9"
        />
        <path
          d="M151.07 1720.19c3.42-120.93 96.12-225.96 108.83-218.35 9.62 5.76-35.67 70.68-21.92 149.88 9.76 56.22 43.75 69.57 32.43 105.78-15.04 48.12-53.96 78.77-86.91 68.47-35.55-11.11-33-85.62-32.43-105.78ZM320.5 1771.26c-28.23-48.31-12.92-111.98-5.4-112.07 5.69-.07 1.55 36.39 27.14 64.16 18.16 19.71 36.53 16.73 40.42 33.69 5.16 22.53-4.57 43.99-21.74 47.91-18.51 4.24-35.71-25.64-40.42-33.69Z"
          className="cls-1hol5"
        />
        <path
          d="M297.8 1603.58c10.1 32.24-17.82 63.02-23.74 61.39-4.48-1.23 7.86-19.89-5.28-40.51-9.33-14.64-24.5-17.14-23.31-27.11 1.58-13.25 14.57-22.6 29.02-20.88 15.59 1.86 21.63 21.74 23.31 27.11Z"
          className="cls-1hol4"
        />
        <path
          d="M343.47 1283.53c38.81 42.46 31.4 110.33 23.04 112.12-6.33 1.36-7.26-36.45-40-58.73-23.24-15.82-43.27-8.64-50.17-24.91-9.17-21.62-1.58-45.52 16.96-53.39 20-8.48 43.71 17.83 50.17 24.91Z"
          className="cls-1hol5"
        />
        <path
          d="M389.8 1494.17c-43.45 58.5-129.7 65.4-133.95 55.39-3.22-7.58 43.6-17.72 63.41-63.85 14.06-32.75.28-56.03 18.85-68.5 24.69-16.58 56.27-12.79 70.54 8.46 15.4 22.92-11.61 58.75-18.85 68.5Z"
          className="cls-1hol2"
        />
        <path
          d="M845.76 1547.25c-47.66 17.38-89.26 18.09-92.56 10.08-1.13-2.75 2.51-5.86 9.08-10.08h83.48Z"
          className="cls-1hol5"
        />
        <path
          d="M154.78 1412.34c45.47-62.69 137.67-68.66 142.4-57.73 3.58 8.28-46.35 18.45-66.75 68.15-14.47 35.28.69 60.77-18.97 73.97-26.13 17.55-60 12.88-75.65-10.42-16.88-25.14 11.39-63.52 18.97-73.97Z"
          className="cls-1hol9"
        />
        <path
          d="M261.51 1409.36c16.19-25.64 53.38-24.92 55.69-20 1.75 3.73-18.14 6.36-24.63 27.25-4.6 14.83 2.46 26.46-5.04 31.5-9.97 6.7-23.88 3.45-31.07-7.25-7.75-11.54 2.34-27.23 5.04-31.5ZM397.07 1683.72c23.59 19.06 18.55 55.92 13.39 57.64-3.91 1.31-4.21-18.76-24.2-27.63-14.19-6.29-26.57-.63-30.7-8.66-5.49-10.68-.65-24.12 10.81-30.01 12.37-6.36 26.77 5.49 30.7 8.66Z"
          className="cls-1hol3"
        />
        <path
          d="M666.39 1804.24c35.1-10.8 68.72 19.19 66.96 25.54-1.33 4.81-21.69-8.46-44.12 5.63-15.92 10-18.6 26.27-29.47 24.98-14.44-1.71-24.67-15.66-22.84-31.16 1.98-16.72 23.62-23.18 29.47-24.98Z"
          className="cls-1hol5"
        />
        <path
          d="M1284.74 1795.13c23.01-37.69 74.79-46.32 77.92-40.47 2.37 4.43-25.38 12.98-34.79 41.96-6.68 20.57 2.95 33.96-7.59 42.48-14 11.32-33.31 10.65-43.13-1.49-10.59-13.1 3.75-36.2 7.59-42.48Z"
          className="cls-1hol4"
        />
        <path
          d="M1659.54 1700.17c17.38 24.15 3.07 57.71-2.26 58.01-4.04.22.88-18.84-15.75-32.41-11.8-9.63-24.98-7.47-26.81-16.15-2.43-11.53 5.63-22.99 18-25.6 13.35-2.81 23.91 12.12 26.81 16.15Z"
          className="cls-1hol3"
        />
        <path
          d="M1540.77 1593.91c3.29 42.71-24.86 83.44-29.54 81.27-3.54-1.64 9.71-26.33 2.03-53.65-5.45-19.4-17.69-22.72-15.12-35.93 3.42-17.55 15.73-29.91 27.5-27.62 12.7 2.47 14.57 28.81 15.12 35.93Z"
          className="cls-1hol4"
        />
        <path
          d="M1829.46 1829.53c-28.59 8.22-55.37-16.57-53.85-21.69 1.15-3.87 17.44 7.18 35.82-3.9 13.05-7.86 15.46-21 24.24-19.79 11.67 1.6 19.74 13.05 18.03 25.58-1.85 13.52-19.48 18.42-24.24 19.79Z"
          className="cls-1hol5"
        />
        <path
          d="M1809.71 1535.17c-26.51-13.5-29.17-49.9-24.56-52.6 3.48-2.05 7.85 17.15 28.84 21.6 14.9 3.16 25.63-4.8 31.23 2.08 7.44 9.13 5.53 23.01-4.28 31-10.58 8.62-26.81.18-31.23-2.08Z"
          className="cls-1hol8"
        />
        <path
          d="M455.44 1309.81v122.65c-19.57-6.68-35.32-20.93-41.96-40.52-10.91-32.19 22.4-65.43 41.96-82.13Z"
          className="cls-1hol3"
        />
        <path
          d="M1257.84 1738.56c-6.55-111.45-105.41-197.82-118.43-189.31-9.85 6.45 38.79 61.23 26.48 136.08-8.74 53.13-43.71 69.43-31.05 101.6 16.82 42.75 57.98 66.59 91.95 53.23 36.64-14.41 32.14-83.03 31.05-101.6Z"
          className="cls-1hol2"
        />
        <path
          d="M1420.1 1547.25c9.26 0 18.27-1.1 26.89-3.19-6.2 31.53-13.25 55.85-41.64 69.89-76.36 37.78-164.32 15.74-196.46-49.22a74.282 74.282 0 0 1-6.08-17.48h217.29ZM1534.19 1368.03v-109.14c84.19-13.64 151.44-3.14 155.63 12.12 4.98 18.12-82.65 29.22-155.63 97.02ZM154.35 865.79c14-101.27 129.7-150.07 143.73-138.05 10.63 9.1-47.04 44.5-37.76 117.79 6.59 52.03 44.69 78.2 28.62 104.03-21.36 34.32-68.81 43.39-105.97 20.26-40.09-24.95-30.95-87.15-28.62-104.03Z"
          className="cls-1hol9"
        />
        <path
          d="M369.46 841.33c32 76.88 1.7 168.7-8.68 167.47-7.86-.93 3.1-54.33-28.21-100.22-22.22-32.57-48.01-31.47-50.92-57.36-3.87-34.41 12.65-64.52 36.9-67.24 26.16-2.94 45.59 44.55 50.92 57.36Z"
          className="cls-1hol4"
        />
        <path
          d="M156.26 1041.88c-28.15 46.71 5.48 105.12 15.61 104.75 7.68-.28-5.34-34 23.44-61.41 20.43-19.46 45.78-17.78 47.54-33.82 2.34-21.31-15.14-40.71-39.06-43.34-25.79-2.84-42.85 26.03-47.54 33.82Z"
          className="cls-1hol6"
        />
        <path
          d="M424.7 1118.65c-53.58-70.83-153.64-94.36-157.98-84.43-3.29 7.52 51.4 27.14 76.96 80.3 18.14 37.73 3.55 60.1 25.74 76.94 29.48 22.39 65.76 24.24 81.03 4.13 16.47-21.69-16.81-65.14-25.74-76.94Z"
          className="cls-1hol9"
        />
        <path
          d="M309.24 1203.78c-34.57 86.06-148.26 100.38-158.13 86.26-7.48-10.69 51.6-27.63 59.34-94.75 5.49-47.65-22.73-80.29-2.78-99.12 26.51-25.03 70.75-21.22 98.8 8.49 30.25 32.05 8.54 84.78 2.78 99.12Z"
          className="cls-1hol4"
        />
        <path
          d="M455.44 928.38v79.1c-43.85 10.18-58.43 48.77-66.1 42.73-10.51-8.28 4.22-90.89 66.1-121.83Z"
          className="cls-1hol7"
        />
        <path
          d="M455.44 805.94v76.51c-14 3.26-24.3 6.55-35.77-1.76-25.93-18.78-35.6-49.68-21.59-69.03 11.2-15.47 38.84-10.85 57.36-5.72Z"
          className="cls-1hol6"
        />
        <path
          d="M455.44 1066.76v52.94c-20.5-28.07-29.46-53.57-24.49-60.63 3.28-4.64 11.49.25 24.49 7.69Z"
          className="cls-1hol4"
        />
        <path
          d="M413.91 1291.61c-29.38 8.55-50.43-25.13-47.94-31.58 1.89-4.89 15.5 10.43 35.53-2.5 14.22-9.17 19.17-25.86 27.46-23.7 11.01 2.87 16.56 18.13 12.41 34.08-4.48 17.21-22.56 22.28-27.46 23.7ZM1632.65 1010.31c-17.94 14.23-41.42-12.84-81.36-13.88-6.11-.16-11.8.25-17.1 1.11v-75.42c6.82-3.39 14.18-6.14 22.08-8.08 12.52-3.07 58.61-14.79 81.36 13.88 21.09 26.58 18.87 63.47-4.98 82.39Z"
          className="cls-1hol2"
        />
        <path
          d="M1635.41 912.3c-6.85 2.68-21.7-46.29-67.78-70.53-12.93-6.79-23.96-8.99-33.44-10.41v-84.17c14.5 6.99 28.12 18.28 33.65 22.8 60.47 49.56 76.61 138.78 67.57 142.31Z"
          className="cls-1hol7"
        />
        <path
          d="M1829.11 1196.49c-24.49 48.02-101.6 40.86-122.51 39.09-82.37-6.99-143.63-66.27-172.41-110.95-15.04-23.34-21.21-42.7-16.9-48.53 2.58-3.49 8.25-1.25 16.9 3.57 23.25 12.96 68.04 44.62 132.14 33.78 62.41-10.56 88.69-56.34 122.51-39.08 44.95 22.93 62.98 77.61 40.27 122.12Z"
          className="cls-1hol9"
        />
        <path
          d="M1719.35 860.03c-64.43 55.48-39.42 158.28-23.7 162.66 11.9 3.31 7.27-52.92 63.9-79.52 40.19-18.88 78.32-4.09 88.32-26.97 13.29-30.4-4.71-67.62-40.2-83.13-38.28-16.73-77.58 17.72-88.32 26.97Z"
          className="cls-1hol6"
        />
        <path
          d="M1731.23 830.7c57.15-21.18 54.99-99.37 43.93-106.65-8.37-5.51-13.97 34.82-60.63 38.03-33.12 2.28-59.27-18.28-70.44-5.08-14.84 17.55-7.37 48.27 16.69 68.62 25.95 21.95 60.91 8.61 70.44 5.08Z"
          className="cls-1hol9"
        />
        <path
          d="M1804.78 1016.22c-35.89 28.83-89.71 18.38-90.71 11.46-.76-5.24 29.47-3.53 48.95-28.74 13.82-17.89 9.11-34.66 22.46-39.22 17.73-6.06 36.43 1.68 41.76 17.28 5.75 16.83-16.48 34.42-22.46 39.22ZM1654.23 1067.57c-2.03 3.57-29.26-12.47-60.48-6.81-22.17 4.01-26.51 16.55-41.3 12.7-7.05-1.84-13.3-4.82-18.26-8.45-8.86-6.47-13.63-15.01-11.6-22.78 1.22-4.68 5.82-7.65 11.6-9.52 10.37-3.36 24.52-3.21 29.7-3.18 48.38.28 93.01 33.33 90.34 38.04Z"
          className="cls-1hol4"
        />
        <path
          d="M1861.11 1380.32c-24.28-67.77-113.21-78.97-121.46-67.84-6.24 8.43 39.65 21.73 43.47 74.6 2.71 37.53-20.59 63.27-5.54 78.09 20.01 19.7 54.93 16.67 77.99-6.76 24.88-25.27 9.58-66.79 5.54-78.09Z"
          className="cls-1hol2"
        />
        <path
          d="M1533.81 1495.6c12.83-88.68 101.49-147.22 111.84-138.97 7.84 6.24-36.58 44.9-31.18 106.27 3.84 43.56 32.1 60.43 19.36 84.86-16.93 32.47-53.04 47.11-80.66 32.71-29.79-15.53-21.5-70.08-19.36-84.86Z"
          className="cls-1hol9"
        />
        <path
          d="M1491.52 1829.9c56.69-38.35 37.06-123.19 23.57-128.2-10.21-3.79-7.29 41.75-56.69 57.69-35.07 11.31-67.7-4.18-76.77 13.21-12.05 23.12 2.78 54.69 33.12 70.51 32.73 17.07 67.32-6.82 76.77-13.21Z"
          className="cls-1hol5"
        />
        <path
          d="M1569.16 1799.1c-37.22-73.23-5.66-164.67 5.88-164.07 8.74.45-2.22 53.25 33.54 96.25 25.38 30.52 53.96 27.95 57.78 53.07 5.07 33.38-12.59 63.75-39.43 67.82-28.95 4.39-51.57-40.86-57.78-53.07ZM1422.23 1713.29c61.76-48.94 65.99-142.47 54.99-146.74-8.33-3.23-17.56 47.75-66.81 70.72-34.96 16.3-60.7 2.17-73.52 22.67-17.04 27.26-11.74 61.29 11.82 76.03 25.42 15.89 63.23-14.52 73.52-22.67Z"
          className="cls-1hol3"
        />
        <path
          d="M457.76 559.59c2.61-12.74 7.34-24.71 13.82-35.51-3.32 12.6-8.09 24.48-13.82 35.51ZM999.27 468.5h27.45c-14.41 16.28-21.18 30.97-25.8 28.43-3.5-1.92-4.37-12.97-1.65-28.43ZM1089.91 1547.25h-29.58c-.78-14.97-1.19-24.45 3.78-25.36 5.41-.99 15.31 8.53 25.8 25.36ZM1534.19 1032.71v32.3c-8.86-6.47-13.63-15.01-11.6-22.78 1.22-4.68 5.82-7.65 11.6-9.52ZM1534.19 1079.67v44.96c-15.04-23.34-21.21-42.7-16.9-48.53 2.58-3.49 8.25-1.25 16.9 3.57Z"
          className="cls-1hol1"
        />
        {children}
      </g>
    </svg>
  );
}
